import {apiClient} from '../../../util/api-client';

export async function makeDownloadQuery(projectId, params): Promise<Blob> {
  // using apiClient.fetch because we're getting back a blob
  // eslint-disable-next-line local-rules/deprecated-member-access
  return apiClient
    .fetch(`/report/${projectId}/download/`, {
      body: JSON.stringify(params),
      method: `POST`,
    })
    .then((response) => response.blob());
}
